import useSWR from "swr";
import { endpointsMembers } from "lib/actions/endpoints/endpointsMembers";
import { fetcher } from "lib/actions/fetcher";
import { MemberModel } from "lib/types/members/MemberModel";
import { ProjectMemberPermissions } from "lib/types/members/ProjectMemberPermissions";
import { updateMemberDetails } from "lib/actions/members/updateMemberDetails";
import { setProjectMemberPermissions } from "lib/actions/members/setProjectMemberPermissions";

export function useProjectMembers(projectId: number) {
  const {
    error: hasError,
    data: members,
    isLoading,
    mutate: mutateProjectMembers,
  } = useSWR<MemberModel[]>(
    projectId && endpointsMembers.projectMembers(projectId),
    fetcher,
  );

  function updateProjectMemberDetails(member: MemberModel) {
    return updateMemberDetails(member).then((response) => {
      mutateProjectMembers((data) =>
        data?.map((member) => (member.id !== member.id ? member : member)),
      );
      return response;
    });
  }

  function updateProjectMemberPermissions(
    id: string,
    permissions: ProjectMemberPermissions,
  ) {
    return setProjectMemberPermissions(projectId, id, permissions).then(
      (response) => {
        mutateProjectMembers((data) =>
          data
            ?.map((member) => ({
              ...member,
              permissions: member.id !== id ? member.permissions : permissions,
            }))
            .filter(
              (member) => member.permissions !== ProjectMemberPermissions.none,
            ),
        );
        return response;
      },
    );
  }

  return {
    members,
    hasError,
    isLoading,
    updateProjectMemberDetails,
    updateProjectMemberPermissions,
    mutateProjectMembers,
  };
}
